module.exports = __webpack_public_path__ + "static/media/rotate-stack.b846a879.svg";